// Author Liang Gang Qiang
// Date 2021-11-22 16:37:12

class MintalMesQualitySelfInspect {
constructor({
        id = null,
        shiftPlanId = '',
        shiftPlanCode = '',
        code = '',
        remark = ''}
= {}) {
    this.id = id;
    this.shiftPlanId = shiftPlanId;
    this.shiftPlanCode = shiftPlanCode;
    this.code = code;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualitySelfInspect();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    shiftPlanIdFilter : '',
    shiftPlanCodeFilter : '',
    codeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'shiftPlanCodeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.filter.shiftPlanCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"shiftPlanId": "id"}'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.entity.shiftPlanCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdShiftPlan'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"shiftPlanId": "id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspect.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualitySelfInspect, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
